import Rest from './base/Rest';

export default class NotificationService extends Rest {
  static resource = 'notification';

  checkImport() {
    return this.index('checkImport');
  }
}
